import {
  Box,
  WithBadge,
  IconButton,
  SystemIcon,
  PlainTooltip,
} from '@wishket/design-system';

import { ArticleToolbarProps, TooltipButtonProps } from '@/shared/types';

const TooltipButton = ({
  id,
  text,
  icon,
  isOpen,
  onClick,
  isTriggered,
}: TooltipButtonProps) => {
  //TODO: WDS 체크박스 z-index 조정 후 툴팁 클래스네임 제거
  return (
    <PlainTooltip
      text={text}
      variant="right"
      className="w-fit"
      disabled={isOpen}
      tooltipClassName="z-[15]"
    >
      <IconButton
        id={id}
        size="lg"
        outline
        className="shrink-0"
        onClick={onClick}
        data-testid={`${text}-button`}
      >
        <SystemIcon name={icon} solid={isTriggered} />
      </IconButton>
    </PlainTooltip>
  );
};

const ArticleColumnToolbar = ({
  like,
  isLiked,
  comment,
  isScrapped,
  isScrapBoxOpen,
  isShareBoxOpen,
  scrapButtonId,
  onLikeClick,
  onCommentClick,
  onScrapClick,
  onShareClick,
}: ArticleToolbarProps) => {
  return (
    <Box id="toolbar" className="flex flex-col gap-4">
      <WithBadge text={like} variant="gray" className="h-[50px]" showZero>
        <TooltipButton
          text="좋아요"
          icon="large_like"
          onClick={onLikeClick}
          isTriggered={isLiked}
        />
      </WithBadge>
      <WithBadge text={comment} variant="gray" className="h-[50px]" showZero>
        <TooltipButton
          text="댓글"
          icon="large_bubble"
          onClick={onCommentClick}
        />
      </WithBadge>
      <TooltipButton
        id={scrapButtonId}
        text={isScrapped ? '스크랩 됨' : '스크랩'}
        icon="large_scrap"
        isOpen={isScrapBoxOpen}
        onClick={onScrapClick}
        isTriggered={isScrapped}
      />
      <TooltipButton
        text="공유"
        icon="large_share"
        isOpen={isShareBoxOpen}
        onClick={onShareClick}
      />
    </Box>
  );
};

export default ArticleColumnToolbar;
